type TestElement = {
  "data-testid"?: string;
};

type Props = {
  labelText?: string;
  dataText?: string | number | null;
  customClass?: string;
  labelProps?: TestElement & React.LabelHTMLAttributes<HTMLLabelElement>;
  valueProps?: TestElement & React.HTMLAttributes<HTMLParagraphElement>;
};

const FieldJSX = ({
  labelText = "",
  dataText,
  customClass,
  labelProps,
  valueProps,
}: Props) => (
  <div className={customClass}>
    <label {...labelProps}>{labelText}:</label>
    {dataText ? <p {...valueProps}>{dataText}</p> : ""}
  </div>
);

export default FieldJSX;
